import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c51c14ec&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c51c14ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51c14ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51c14ec')) {
      api.createRecord('c51c14ec', component.options)
    } else {
      api.reload('c51c14ec', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=c51c14ec&scoped=true", function () {
      api.rerender('c51c14ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/component/detail.vue"
export default component.exports